import { useCallback, useMemo, useState } from "react";

import GlobalContainer from "~/components/global_container";

export const preferenceKey = (
  teamId,
  name,
  product = GlobalContainer.product(),
) =>
  JSON.stringify([
    "custom-fields-ui-v1",
    Rails?.helpers?.currentUser?.id,
    teamId,
    product,
    name,
  ]);

const read = (key, fallback) => {
  try {
    const value = JSON.parse(sessionStorage.getItem(key));
    return typeof value === typeof fallback ? value : fallback;
  } catch {
    return fallback;
  }
};

// Store only presentation preferences, never field data or authorization decisions.
const useSessionPreference = (key, fallback) => {
  const initial = useMemo(() => read(key, fallback), [key, fallback]);
  const [state, setState] = useState({ key, value: initial });
  const value = state.key === key ? state.value : initial;
  const setValue = useCallback(
    (next) => {
      const updated = typeof next === "function" ? next(value) : next;
      try {
        sessionStorage.setItem(key, JSON.stringify(updated));
      } catch {
        /* Storage may be blocked. */
      }
      setState({ key, value: updated });
    },
    [key, value],
  );
  return [value, setValue];
};
export default useSessionPreference;
